// extracted by mini-css-extract-plugin
export default {"ldsroller":"style_ldsroller__hjlnW","lds-roller":"style_lds-roller__TwS+V"};